import request from '@/utils/request'

export function editProduct(data) {
  return request({
    url: '/Api/brand.BrandProduct/editProduct',
    method: 'post',
    data
  })
}
export function saveProduct(data) {
  return request({
    url: '/Api/brand.BrandProduct/saveProduct',
    method: 'post',
    data
  })
}
export function changeProductStatus(data) {
  return request({
    url: '/Api/brand.BrandProduct/changeProductStatus',
    method: 'post',
    data
  })
}
export function delProduct(data) {
  return request({
    url: '/Api/brand.BrandProduct/deleteProduct',
    method: 'post',
    data
  })
}
export function getProductList(data) {
  return request({
    url: '/Api/brand.BrandProduct/productList',
    method: 'post',
    data
  })
}
export function getUnpopList(data) {
  return request({
    url: '/Api/brand.BrandProduct/unpopList',
    method: 'post',
    data
  })
}
export function getDataProduct(data) {
  return request({
    url: '/Api/brand.BrandProduct/index',
    method: 'post',
    data
  })
}
export function set_commission(data) {
  return request({
    url: '/Api/brand.BrandProduct/setCommissionRate',
    method: 'post',
    data
  })
}
export function pop(data) {
  return request({
    url: '/Api/brand.BrandProduct/pop',
    method: 'post',
    data
  })
}
export function set_product_commission(data) {
  return request({
    url: '/Api/brand.BrandProduct/setProductCommissionRate',
    method: 'post',
    data
  })
}
export function updateStatus(data){
	return request({
	  url: '/Api/brand.BrandProduct/updateStatus',
	  method: 'post',
	  data
	})
}
export function get_add_edit(data){
	return request({
	  url: '/Api/brand.BrandProduct/addOrEdit',
	  method: 'post',
	  data
	})
}
export function get_product_info(data){
	return request({
	  url: '/Api/brand.BrandProduct/addOrEditView',
	  method: 'post',
	  data
	})
}
export function agreeProtocol(data){
	return request({
	  url: '/Api/brand.BrandProduct/agreeProtocol',
	  method: 'post',
	  data
	})
}
export function getProtocol(data){
	return request({
	  url: '/Api/brand.BrandProduct/getProtocol',
	  method: 'post',
	  data
	})
}
export function getCategoryList(data){
	return request({
	  url: '/Api/brand.BrandProduct/categoryList',
	  method: 'post',
	  data
	})
}

export function getCateApplyInfo(data){
	return request({
	  url: '/Api/brand.CateApply/getInfo',
	  method: 'post',
	  data
	})
}

export function cateApply(data){
	return request({
	  url: '/Api/brand.CateApply/cateApply',
	  method: 'post',
	  data
	})
}

export function cateApplyFree(data){
	return request({
	  url: '/Api/brand.CateApply/cateApplyFree',
	  method: 'post',
	  data
	})
}

export function getCateInfo(data){
	return request({
	  url: '/Api/brand.CateApply/getCateInfo',
	  method: 'post',
	  data
	})
}
export function getGoodsCate(data){
	return request({
	  url: '/Api/brand.CateApply/getBrandCate',
	  method: 'post',
	  data
	})
}
export function getOrder(data){
	return request({
	  url: '/Api/brand.CateApply/getOrderStatus',
	  method: 'post',
	  data
	})
}
export function getMchStatus(data){
	return request({
	  url: 'Api/brand.BrandProduct/getMchStatus',
	  method: 'post',
	  data
	})
}
export function getBrandPlanList(data) {
  return request({
    url: '/Api/brand.EcsPlan/getEcsPlanList',
    method: 'post',
    data
  })
}
export function addBrandPlan(data) {
  return request({
    url: '/Api/brand.EcsPlan/addEcsPlan',
    method: 'post',
    data
  })
}
export function setBrandPlanCommission(data) {
  return request({
    url: '/Api/brand.EcsPlan/setEcsPlanCommission',
    method: 'post',
    data
  })
}
export function setBrandPlanStatus(data) {
  return request({
    url: '/Api/brand.EcsPlan/setEcsPlanStatus',
    method: 'post',
    data
  })
}
export function getBrandPlanEvent(data) {
  return request({
    url: '/Api/brand.EcsPlan/getEcsPlanEvent',
    method: 'post',
    data
  })
}
export function getBrandPlanEventInfo(data) {
  return request({
    url: '/Api/brand.EcsPlan/getEcsPlanEventInfo',
    method: 'post',
    data
  })
}
export function getBrandPlanData(data) {
  return request({
    url: '/Api/brand.EcsPlan/getEcsPlanData',
    method: 'post',
    data
  })
}
export function getBrandPlanChart(data) {
  return request({
    url: '/Api/brand.EcsPlan/getEcsPlanChart',
    method: 'post',
    data
  })
}
export function getProductClassify(data) {
  return request({
    url: '/Api/brand.BrandProduct/getProductClassify',
    method: 'post',
    data
  })
}
// 获取商品信息库可关联的产品
export function getDepotProductList(data) {
  return request({
    url: '/Api/brand.BrandProduct/getDepotProductList',
    method: 'post',
    data
  })
}